export const WORLD_CUP_COMPETITION_CODE = "WC";

export const FOOTBALL_DATA_CODE_BY_LEAGUE_SLUG: Record<string, string> = {
  "premier-league": "PL",
  "la-liga": "PD",
  "serie-a": "SA",
  bundesliga: "BL1",
  "bajnokok-ligaja": "CL",
  "europa-liga": "EL",
  "world-cup": WORLD_CUP_COMPETITION_CODE,
};

export const LEAGUE_SLUG_BY_FOOTBALL_DATA_CODE = Object.fromEntries(
  Object.entries(FOOTBALL_DATA_CODE_BY_LEAGUE_SLUG).map(([leagueSlug, code]) => [code, leagueSlug]),
) as Record<string, string>;

export function footballDataCodeForLeagueSlug(slug: string | null | undefined) {
  if (!slug) return null;
  const normalized = slug.trim().toLowerCase();
  return FOOTBALL_DATA_CODE_BY_LEAGUE_SLUG[normalized] ?? slug.trim().toUpperCase();
}

export function footballDataCodeMatchesLeagueSlug(
  code: string | null | undefined,
  leagueSlug: string | null | undefined,
) {
  const expectedCode = footballDataCodeForLeagueSlug(leagueSlug);
  if (!expectedCode || !code) return false;
  return code.toUpperCase() === expectedCode;
}
